import { store, getContext, getElement } from '@wordpress/interactivity';
const { decodeEntities } = window.wp.htmlEntities; // see alluvium-blocks.php

const ACTIVE_CLASS = 'visible';
const LOADED_CLASS = 'modal-content-loaded';

function filterStaff(e) {
    const searchInput = e.target;
    const searchTerm = searchInput.value.trim().toLowerCase();
    const staffWrapper = searchInput.closest('.wp-block-alluvium-staff-wrapper');
    const staffBlocks = staffWrapper.querySelectorAll('.staff-block');

    staffBlocks.forEach(block => {
        const name = block.querySelector('.staff-block_content-name').textContent.toLowerCase();
        const title = block.querySelector('.staff-block_content-title').textContent.toLowerCase();
        const isMatch = name.includes(searchTerm) || title.includes(searchTerm);
        block.classList.toggle('hidden', !isMatch);
    });
}

// Add debounced version of filterStaff
const debouncedFilterStaff = debounce(filterStaff, 300);

// Debounce helper function
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function openModal(key) {
    const modal = document.getElementById('staff-modal');
    modal.classList.add(ACTIVE_CLASS);
    document.documentElement.style.overflow = 'hidden';

    // As soon as the state changes, the modal will be updated
    state.modal_context = state.staff[key];
    history.replaceState(null, '', window.location.pathname + '#' + key);
    modal.classList.add(LOADED_CLASS);
    
    // Track view
    setTimeout(function() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'view_staff_modal',
            'staff_name': state.modal_context.staff_name
        });
    }, 100);
}

function closeModal(e) {
    if (e.target.matches('.staff-modal-overlay, .close-icon, .close-icon *') || e.key === 'Escape') {
        const modal = document.getElementById('staff-modal');
        modal.classList.remove(ACTIVE_CLASS, LOADED_CLASS);
        document.documentElement.style.overflow = 'auto';
        history.pushState("", document.title, window.location.pathname + window.location.search);
    }
}

const { state } = store( 'alluvium/staff', {
    state: {
        modal_context: null,
        get modalContext() {
            return state.modal_context;
        }
    },
    actions: {
        openModal: () => {
            const { ref } = getElement();
            const key = ref.dataset.wpKey;
            openModal(key);
        },
        closeModal: closeModal,
        filterStaff: debouncedFilterStaff
    },
    callbacks: {
        maybeOpenModal: () => {
            const { ref } = getElement();
            const key = ref.dataset.wpKey;
            const urlHash = window.location.hash.replace('#', '');
            if (key === urlHash) {
                openModal(key);
            } else {
                // We've redirected old staff profiles to ?staff=slug so this attempt to open the modal for them
                const urlParams = new URLSearchParams(window.location.search);
                const staffParam = urlParams.get('staff');
                if (staffParam) {
                    const value = staffParam.replace('-', '_');
                    if (key === value) {
                        openModal(value);
                    }
                }
            }
        },
        updateModal: () => {
            // Some data in the modal is updated automatically when modal_context changes
            // We need to update the links, image and description here

            if (!state.modal_context) return;
            const { ref } = getElement();

            // Update links
            const emLink = ref.querySelector('.social-em');
            const liLink = ref.querySelector('.social-li');
            emLink.href = 'mailto:' + state.modal_context.staff_link_em;
            liLink.href = state.modal_context.staff_link_li;

            // Update image
            const imageElement = ref.querySelector('.staff-modal_portrait img');
            imageElement.src = state.modal_context.staff_featured_image_url;

            // Update description
            const descriptionElement = ref.querySelector('.staff-modal_description p');
            descriptionElement.innerHTML = state.modal_context.staff_description;
        },
        // Hydrate staff data in each block
        // This is overkill for such a simple block but means the page can be cached
        // and the staff data will always be up to date
        updateStaff: () => {
            const { ref } = getElement();
            const staffBlocks = ref.querySelectorAll('.staff-block');            
            const staffSlugs = Array.from(staffBlocks).map(block => block.dataset.slug);
            fetch(`/wp-json/wp/v2/staff?slug=${staffSlugs.join(',')}&_embed`)
                .then(response => response.json())
                .then(staffData => {
                    if (staffData && staffData.length > 0) {
                        const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);

                        staffBlocks.forEach(item => {
                            const slug = item.dataset.slug;
                            const staffMember = staffData.find(member => member.slug === slug);

                            if (staffMember) {
                                const lastModified = new Date(staffMember.modified);
                                const key = staffMember.slug.replace(/-/g, '_');

                                if (lastModified > twentyFourHoursAgo) {
                                    state.staff[key].staff_name = decodeEntities(staffMember.meta.staff_name);
                                    state.staff[key].staff_title = decodeEntities(staffMember.meta.staff_title);
                                    state.staff[key].staff_description = decodeEntities(staffMember.meta.staff_description);
                                    state.staff[key].staff_link_em = staffMember.meta.staff_link_em;
                                    state.staff[key].staff_link_li = staffMember.meta.staff_link_li;

                                    // Update image if it exists
                                    const imageElement = item.querySelector('.staff-block_portrait-image');
                                    if (imageElement && staffMember.featured_media) {
                                        const imageSrc = staffMember._embedded['wp:featuredmedia'][0].source_url;
                                        state.staff[key].staff_featured_image_url = imageSrc;
                                        imageElement.src = imageSrc;
                                        imageElement.srcset = ''; // Wish there was a way to return srcset in JS
                                    }
                                    console.log('Updated state for: ', state.staff[key].staff_name);
                                }
                            }
                        });
                    } else {
                        console.log('No staff data found.');
                    }
                })
                .catch(error => console.error('Error fetching staff details:', error));
        }
    }
});

export {
    openModal,
    closeModal
};